// extracted by mini-css-extract-plugin
module.exports =  {"policyLinkContainer":"PoliciesTable_policyLinkContainer__zR60s","currencyContainer":"PoliciesTable_currencyContainer__hIU7R"};